var render, staticRenderFns
import script from "./associated_customer_one.vue?vue&type=script&lang=js"
export * from "./associated_customer_one.vue?vue&type=script&lang=js"
import style0 from "./associated_customer_one.vue?vue&type=style&index=0&id=7272647e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7272647e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7272647e')) {
      api.createRecord('7272647e', component.options)
    } else {
      api.reload('7272647e', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/user_client_management/form/associated_customer/associated_customer_one.vue"
export default component.exports